// Interfaces
import { IRouteParent } from 'routes/route.interface'

// Constant
import { PERSONAL_DATA_MODULE, PERSONAL_DATA_URL } from 'constant/url.constant'
import { ACCESS_CODE_PERSONAL_DATA } from 'constant/access.constant'

// Profile (Personal Data + Document Upload History)
import { profileRoutes } from './profile.router'
import { myDocumentRoutes } from './my-document.router'
import { companyRoutes } from './company.router'
import { additionalQuestionRoutes } from './additional-question.router'

const personalDataRoutes: IRouteParent = {
  path: PERSONAL_DATA_URL.PROFILE,
  meta: {
    attrs: {
      module: PERSONAL_DATA_MODULE,
      icon: 'back-office/icon-user',
      label: 'backOffice.profileData',
      accessCodes: ACCESS_CODE_PERSONAL_DATA,
    },
  },
  children: [...profileRoutes, ...companyRoutes, ...additionalQuestionRoutes, ...myDocumentRoutes,],
}

export { personalDataRoutes }
